import { useRef, useEffect } from 'react';
import { useCustomEvent } from '@wix/da-hooks/pkg/useCustomEvent';
import { scrollIntoViewInViewportBottom, scrollIntoViewInViewportCenter } from '../../../utils/scrollIntoViewWithHeader';
import panelPopupStyles from './PanelPopup.scss';
const transitionDuration = parseFloat(panelPopupStyles['transitionDuration']) * 1000;
export function useCustomTransitionEvents(rootRef, isVisible, panelType) {
    const previousPanel = useRef(isVisible);
    const { emit: emitOpen , subscription: openEvent  } = useCustomEvent('open');
    const { emit: emitClose , subscription: closeEvent  } = useCustomEvent('close');
    const { emit: emitOpenAnimationDone , subscription: openAnimationEvent  } = useCustomEvent('openAnimation');
    const { emit: emitCloseAnimationDone , subscription: closeAnimationEvent  } = useCustomEvent('closeAnimation');
    useEffect(()=>{
        const root = rootRef.current;
        const wasVisible = previousPanel.current;
        if (!root) {
            return;
        }
        let transitionTimeout;
        function onTransitionEnd() {
            if (transitionTimeout) {
                clearTimeout(transitionTimeout);
                transitionTimeout = undefined;
            }
            if (wasVisible && !isVisible) {
                emitCloseAnimationDone();
            } else if (isVisible && !wasVisible) {
                if (root) {
                    if (panelType === 'comment') {
                        scrollIntoViewInViewportCenter(root, false, undefined, true);
                    } else {
                        scrollIntoViewInViewportBottom(root, false, 80, undefined, true);
                    }
                }
                emitOpenAnimationDone();
            }
        }
        if (wasVisible && !isVisible) {
            emitClose();
            // timeout in case the animation failed to play for whatever reason
            transitionTimeout = setTimeout(onTransitionEnd, transitionDuration);
        } else if (isVisible && !wasVisible) {
            emitOpen();
            if (panelType === 'comment') {
                onTransitionEnd();
            } else {
                transitionTimeout = setTimeout(onTransitionEnd, transitionDuration);
            }
        }
        previousPanel.current = isVisible;
        root.addEventListener('transitionend', onTransitionEnd);
        return ()=>root.removeEventListener('transitionend', onTransitionEnd);
    }, [
        emitClose,
        emitCloseAnimationDone,
        emitOpen,
        emitOpenAnimationDone,
        isVisible,
        panelType,
        rootRef
    ]);
    return {
        openAnimationEvent,
        closeAnimationEvent,
        openEvent,
        closeEvent
    };
}
